import { render } from "./ChapterItem.vue?vue&type=template&id=57b0e178&scoped=true&ts=true"
import script from "./ChapterItem.vue?vue&type=script&lang=ts"
export * from "./ChapterItem.vue?vue&type=script&lang=ts"

import "./ChapterItem.vue?vue&type=style&index=0&id=57b0e178&lang=stylus"
import "./ChapterItem.vue?vue&type=style&index=1&id=57b0e178&lang=stylus&scoped=true"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57b0e178"]])

export default __exports__